import { Collapse } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import clsx from 'clsx'

const EduNavAppMenu = ({ mobileMenuOpen, menuClassName, toggleMenu }) => {
  return (
    <Collapse in={mobileMenuOpen} className="navbar-collapse collapse">
      <div>
        <ul className={clsx('navbar-nav navbar-nav-scroll', menuClassName)}>
          {/* <li className="nav-item">
            <Link className="nav-link" to="/demos/edunav/home">
              Home
            </Link>
          </li> */}
          <li className="nav-item">
            <Link className="nav-link" to="/ground-reality" onClick={toggleMenu}>
              Ground Reality
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/who-we-are" onClick={toggleMenu}>
              Who We Are
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/what-we-do" onClick={toggleMenu}>
              What We Do
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/courses" onClick={toggleMenu}>
              Courses
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/purpose" onClick={toggleMenu}>
              Purpose & Core Values
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/experiences" onClick={toggleMenu}>
              Experiences
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/contact"  onClick={toggleMenu}>
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </Collapse>
  )
}

export default EduNavAppMenu
